import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { ShipmentDocumentService } from 'common/data';

class ShipmentDocumentStore extends BaseStore {
	constructor(rootStore) {
		super(new ShipmentDocumentService(rootStore.app.baasic.apiClient));
	}

	@action
	async upload(files) {
		 await this.service.upload(files);
	}

	@action
	uploadDocument = async (fulfillmentOrderId, type, data) => {
		const response = await this.service.uploadDocument(fulfillmentOrderId, type, data);
		return response.data;
	};

	@action
	printDocument = async (fulfillmentOrderId, type) => {
		const response = await this.service.printDocument(fulfillmentOrderId, type);
		return response.data;
	};

	@action
	getForFulfillmentOrder = async fulfillmentOrderId => {
		const response = await this.service.getForFulfillmentOrder(fulfillmentOrderId);
		return response.data;
	};
}

export default ShipmentDocumentStore;
